export const upcomingGames = [
  {
    id: 1,
    day: 'SAT',
    date: 'AUG 9',
    opponent: 'Las Vegas Raiders',
    opponentShort: 'Raiders',
    location: 'HOME',
    venue: 'US Bank Stadium, Minneapolis',
    time: '1:00 PM CT',
    opponentLogo: 'https://public.readdy.ai/ai/img_res/6d2196ad109bee4b552650b36bc755a1.jpg',
  },
  {
    id: 2,
    day: 'SAT',
    date: 'AUG 16',
    opponent: 'Chicago Bears',
    opponentShort: 'Bears',
    location: 'AWAY',
    venue: 'Soldier Field, Chicago',
    time: '7:30 PM CT',
    opponentLogo: 'https://readdy.ai/api/search-image?query=Chicago%20Bears%20NFL%20team%20logo%20orange%20navy%20blue%20bear%20emblem%20clean%20vector%20style%20transparent%20background&width=80&height=80&seq=bears1&orientation=squarish',
  },
  {
    id: 3,
    day: 'FRI',
    date: 'AUG 22',
    opponent: 'Green Bay Packers',
    opponentShort: 'Packers',
    location: 'HOME',
    venue: 'US Bank Stadium, Minneapolis',
    time: '8:00 PM CT',
    opponentLogo: 'https://readdy.ai/api/search-image?query=Green%20Bay%20Packers%20NFL%20team%20logo%20green%20gold%20G%20emblem%20clean%20vector%20style%20transparent%20background&width=80&height=80&seq=packers1&orientation=squarish',
  },
  {
    id: 4,
    day: 'THU',
    date: 'AUG 28',
    opponent: 'Detroit Lions',
    opponentShort: 'Lions',
    location: 'AWAY',
    venue: 'Ford Field, Detroit',
    time: '8:15 PM CT',
    opponentLogo: 'https://readdy.ai/api/search-image?query=Detroit%20Lions%20NFL%20team%20logo%20blue%20silver%20lion%20emblem%20clean%20vector%20style%20transparent%20background&width=80&height=80&seq=lions1&orientation=squarish',
  },
  {
    id: 5,
    day: 'SUN',
    date: 'SEP 7',
    opponent: 'Dallas Cowboys',
    opponentShort: 'Cowboys',
    location: 'HOME',
    venue: 'US Bank Stadium, Minneapolis',
    time: '3:25 PM CT',
    opponentLogo: 'https://readdy.ai/api/search-image?query=Dallas%20Cowboys%20NFL%20team%20logo%20blue%20silver%20star%20emblem%20clean%20vector%20style%20transparent%20background&width=80&height=80&seq=cowboys1&orientation=squarish',
  },
];
